const transformVideoData = require("./transformVideoData");
const extractLinkData = require("./extractLinkData");
const extractButtonData = require("./extractButtonData");
const extractFileData = require("./extractFileData");
const findFeaturedImage = require("./findFeaturedImage");
const slugify = require("./slugify");

module.exports = function transformHighlightData(entity, sitemap) {
	const { attributes, id, type, relationships } = entity;

	const buttons =
		attributes && Array.isArray(attributes.field_buttons)
			? attributes.field_buttons.map((a_btn) => extractLinkData(a_btn, sitemap))
			: [];

	if (attributes && attributes.field_to) {
		buttons.push(extractLinkData(attributes.field_to, sitemap));
	}

	const button_entities =
		relationships && relationships.field_buttons_entities
			? relationships.field_buttons_entities
			: null;

	if (button_entities && button_entities.data) {
		button_entities.data.forEach((btn) => {
			const btn_data = extractButtonData(btn, sitemap);
			if (btn_data) {
				buttons.push(btn_data);
			}
		});
	}

	let video;
	let image;
	let _image_rel = findFeaturedImage(relationships);
	if (_image_rel) {
		video =
			_image_rel.type === "media--video"
				? transformVideoData(undefined, undefined, _image_rel)
				: null;
		image =
			_image_rel.type === "media--image"
				? extractFileData(_image_rel, "field_media_image")
				: null;
	}
	let txt = attributes.body
		? attributes.body.transformed
			? attributes.body.transformed
			: attributes.body.value
		: null;

	// const orientations = ["landscape", "portrait", "square", "rounded", "full"];
	// const orientation = orientations[Math.floor(Math.random() * orientations.length)];
	// const orientation = orientations[0];
	const orientation =
		attributes && attributes.field_image_orientation
			? attributes.field_image_orientation
			: null;

	// const layouts = ["left", "right", "top"];
	// const layout = layouts[Math.floor(Math.random() * layouts.length)];
	// const layout = layouts[1];
	const layout =
		attributes && attributes.field_highlight_layout
			? attributes.field_highlight_layout
			: null;

	// const styles = ["default", "overlap", "frame"];
	// const style = styles[Math.floor(Math.random() * styles.length)];
	// const style = styles[2];
	const style =
		attributes && attributes.field_highlight_style
			? attributes.field_highlight_style
			: "default";

	const underline = attributes.field_color_hex ? attributes.field_color_hex : null;

	// const underline = Math.random() < 0.5 ? "#ff0000" : null;

	const buttonColor = attributes.field_color ? attributes.field_color : "secondary";
	const buttonStyle = attributes.field_button_style
		? attributes.field_button_style
		: "default";

	const icono = attributes.field_icono ? attributes.field_icono : null;
	const textAlign = attributes.field_align ? attributes.field_align : "left";
	const contained = attributes.field_contained ? attributes.field_contained : false;
	const headingType = attributes.field_heading_type
		? attributes.field_heading_type
		: "h2";
	let data = {
		id,
		type,
		title: attributes.title,
		anchor: slugify(attributes.title),
		video,
		image,
		text: txt,
		buttons: buttons.map((btn) => ({
			type: buttonStyle,
			color: buttonColor,
			...btn,
		})),
		orientation,
		layout,
		style,
		fullWidth: false,
		underline,
		buttonColor,
		buttonStyle,
		icon: icono,
		textAlign,
		headingType,
		contained,
	};
	return data;
};
